module.exports = __webpack_public_path__ + "media/images/lp/voice4-close-2c4f9130b68357fc6cc7c47c4b99aa8d.png";